<!--
 * @Descripttion: 
 * @version: 
 * @Author: A21
 * @Date: 2022-05-26 15:32:40
 * @LastEditors: A21
 * @LastEditTime: 2022-06-01 12:18:33
 * @FilePath: /intell-loan/src/components/FeildTwo/components/AuthorizationContract.vue
-->
<template>
  <div class="base_color">
    <div id="container">
      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div style="text-align: left;" class="clause">
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-align:center; widows:0; orphans:0; font-size:22pt"
        >
          <span style="font-family:'宋体'; font-weight:bold">个人信息查询和提供在线授权书</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:10.5pt">
          <span style="font-family:Calibri">&#xa0;</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'">上海浦东发展银行股份有限公司：</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">本人（</span
          ><span style="font-family:'仿宋_GB2312'"
            >“授权人”）在此不可撤销地授权贵行（“被授权人”）根据本授权书查询和提供授权人的信息。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'; font-weight:bold">★一、授权事项</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">（一）</span
          ><span style="font-family:'仿宋_GB2312'">授权人个人信息的查询和使用</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >授权人在办理本业务时，被授权人依法可以通过如下途径获取您的以下信息：</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >向中国人民银行金融信用信息基础数据库及其他经中国人民银行批准设立的征信机构查询授权人的全部信用信息及信用报告。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >向资信评估机构、风险管理专业机构或有关法律、监管机构许可的类似数据机构查询、核实、打印、留存您的信息和（或）信用报告。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >向行政机关、事业单位、司法机关、监管部门、中国互联网金融协会等行业自律组织查询、打印、留存任何与本业务相关信息。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">（二）</span
          ><span style="font-family:'仿宋_GB2312'">授权信息范围：</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'">授权人同意被授权人收集的信息包括但不限于：</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'">授权人的姓名</span
          ><span style="font-family:'仿宋_GB2312'">/</span
          ><span style="font-family:'仿宋_GB2312'"
            >名称、证件类型及号码、户籍所在地、住所地、经常居住地、电话号码、在被授权人处开立的账户认证信息、人脸识别所需生物特征以及其他身份信息。</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'"
            >授权人在申请、办理本业务时，访问本行服务网站或业务移动设备客户端时的操作日志、包括但不限于授权人的计算机</span
          ><span style="font-family:'仿宋_GB2312'">IP</span
          ><span style="font-family:'仿宋_GB2312'"
            >地址、设备标识符、硬件型号、操作系统版本、授权人位置信息等。</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'"
            >授权人在申请、办理本业务时所提供、形成的任何数据和信息，包括但不限于授权人提供的关联数据信息</span
          ><span style="font-family:'仿宋_GB2312'">.</span>
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'"
            >授权人的财产信息，包括但不限于授权人的财税信息、房产信息、车辆信息、基金、保险、股票、信托、债券等投资理财信息和负债信息等。</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'"
            >授权人在各机构留存的任何信息，包括但不限于授权人作为法定代表人或负责人或经营者或股东的工商信息、诉讼信息、执行信息和违法犯罪信息等。</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'"
            >授权人在此同意并确认，授权人在前述信息提供给被授权人之前，已清楚知晓可能带来的不利后果，包括但不限于基于前述信息对授权人</span
          ><span style="font-family:'仿宋_GB2312'">作出</span
          ><span style="font-family:'仿宋_GB2312'">的负面评价。</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">（三）</span
          ><span style="font-family:'仿宋_GB2312'">授权人信息的对外提供</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >根据征信相关法律法规和监管规定的要求，被授权人有权将在双方相关授信业务关系建立和存续期间获得的与本授权人有关的信息，包括信贷信息、信用信息、个人基本信息、不良信息和其他信息资料，提供给金融信用信息基础数据库及其他经中国人民银行批准设立的征信机构的数据库。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'; font-weight:bold">★二、信息使用</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >授权信息用于审核本人授信和贷款申请，以及对已发放的个人信贷进行贷后管理；</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'">基于本人</span
          ><span style="font-family:'仿宋_GB2312'">/</span
          ><span style="font-family:'仿宋_GB2312'">本单位资格审查、授</span
          ><span style="font-family:'仿宋_GB2312'">信方案</span
          ><span style="font-family:'仿宋_GB2312'"
            >制定、信贷资产质量监控、债务追索、担保方案制定、担保资产质量监控、担保责任追索、关联关系查询及其他为确保实现被授权人在相关授信业务合同</span
          ><span style="font-family:'仿宋_GB2312'">下利益</span
          ><span style="font-family:'仿宋_GB2312'"
            >之目的，被授权人有权查询、使用和保存前述信用信息及信用报告。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'; font-weight:bold">★三、授权期限</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">授权期限自本授权书载明的签署日期</span
          ><span style="font-family:'仿宋_GB2312'">起至授信</span
          ><span style="font-family:'仿宋_GB2312'"
            >意向下发生的业务（如有）完全履行完毕之日止。如被授权人经审核拒绝接受本授权人的申请，则授权期限至被授权人正式通知本授权人之日止。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'; font-weight:bold">四、其他</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >如被授权人超出本授权书的范围违法查询和使用本授权人的信用信息，被授权人应承担相应的法律责任。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'"
            >被授权人将严格根据法律法规规定及相关合同对授权人的个人信息和隐私予以保密；在收集、使用、对外提供经本授权人授权的信息及其他资料时，被授权人将同时依据与授权人签署的其他隐私权政策或条款进行保密与规范（如有）。</span
          >
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'; font-weight:bold"
            >本授权人知悉和完全理解本授权书的内容，尤其是标记</span
          ><span style="font-family:'仿宋_GB2312'; font-weight:bold"
            >★的条款，本授权书下的授权是本授权人自愿</span
          ><span style="font-family:'仿宋_GB2312'; font-weight:bold">作出</span
          ><span style="font-family:'仿宋_GB2312'; font-weight:bold">的真实意</span
          ><span style="font-family:'仿宋_GB2312'; font-weight:bold"
            >思表示，并愿意承担相应的法律责任。经本授权人通过在线确认同意即视为签署本授权书并生效。</span
          >
        </p>
        <p style="margin-top:0pt; margin-bottom:0pt; widows:0; orphans:0; font-size:16pt">
          <span style="font-family:'仿宋_GB2312'">&#xa0;</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">授权人（姓名）：</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">授权人居民身份证号码：</span
          ><span style="font-family:'仿宋_GB2312'; color:#ff0000"> </span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-indent:16pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:16pt"
        >
          <span style="font-family:'仿宋_GB2312'">授权日期：</span
          ><span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'">年</span
          ><span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'">月</span
          ><span style="font-family:'仿宋_GB2312'"> </span
          ><span style="font-family:'仿宋_GB2312'">日</span>
        </p>
        <p
          style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt"
        >
          <span style="font-family:Calibri">&#xa0;</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FeildTwo',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null
    }
  },
  methods: {
    close() {
      this.hidePopup();
    }
  }
};
</script>
<style scoped>
.base_color {
  width: 100%;
  height: 100%;
}
.crossBox {
  text-align: right;
}
.cross {
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  /* text-indent: 6px; */
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
</style>
